// Authentication service - provides access token for API calls

// Global MSAL instance (set by index.js during app initialization)
let msalInstance = null;

/**
 * Initialize the auth service with MSAL instance
 * Called by index.js during app startup
 */
export function initAuthService(instance, accounts) {
  console.log('[Auth] Initializing auth service');
  console.log('[Auth] MSAL instance:', instance ? 'PROVIDED' : 'NULL');
  console.log('[Auth] Accounts at init:', accounts?.length || 0);
  msalInstance = instance;
  // Don't cache accounts - get them fresh each time
}

/**
 * Get the current user's ID token for API authentication
 * Returns null if not authenticated
 */
export async function getAccessToken() {
  console.log('[Auth] getAccessToken called');

  if (!msalInstance) {
    console.error('[Auth] MSAL instance not initialized');
    return null;
  }

  // Get fresh accounts each time instead of using cached ones
  const currentAccounts = msalInstance.getAllAccounts();
  console.log('[Auth] Current accounts:', currentAccounts?.length || 0);

  if (!currentAccounts || currentAccounts.length === 0) {
    console.warn('[Auth] No accounts available');
    return null;
  }

  const account = currentAccounts[0];
  console.log('[Auth] Using account:', account.username);

  // The ID token is already available from the account object after login
  // This token has our client ID as the audience, which is what the backend expects
  if (account.idToken) {
    console.log('[Auth] Using cached ID token from account');
    console.log('[Auth] Token preview:', account.idToken.substring(0, 50) + '...');
    return account.idToken;
  }

  console.warn('[Auth] No ID token available in account object');
  return null;
}
